import React, { useEffect, useState } from "react";
import combosData from "../data/combos-and-packs.json";
import ComboList from "./ComboList";

const CombosPage = () => {
  const [combos, setCombos] = useState([]);

  useEffect(() => {
    const activeSorted = combosData.combos
      .filter((c) => c.productstatus === "Active")
      .sort((a, b) => a.priority - b.priority);

    setCombos(activeSorted);
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Combos & Packs</h1>
      <p className="text-lg mt-4">Explore our special bundles for the best skin care regimen!</p>
      <ComboList combos={combos} />
    </div>
  );
};

export default CombosPage;
